import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Accommodation from "./pages/Accommodation";
import Services from "./pages/Services";
import PlacesToVisit from "./pages/PlacesToVisit";
import ContactUs from "./pages/ContactUs";
import UnderConstruction from "./pages/UnderConstruction";

const SITE_UNDER_CONSTRUCTION = true;

function App() {
  return (
    <div className="App">
      <BrowserRouter>

        {!SITE_UNDER_CONSTRUCTION && <Header />}

        <Routes>
          {SITE_UNDER_CONSTRUCTION ? (
            <>
              <Route path="*" element={<UnderConstruction />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/accommodation" element={<Accommodation />} />
              <Route path="/services" element={<Services />} />
              <Route path="/places" element={<PlacesToVisit />} />
              <Route path="/contact" element={<ContactUs />} />
            </>
          )}
        </Routes>

        {!SITE_UNDER_CONSTRUCTION && <Footer />}
        {!SITE_UNDER_CONSTRUCTION && <WhatsAppButton />}

        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
